import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useState } from 'react';
import shallow from 'zustand/shallow';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FiMap } from 'react-icons/fi';
import { FaQuestion } from 'react-icons/fa';
import { GiJourney } from 'react-icons/gi';
import { getMetric, getRoundedValue, toTitleCase, getFeederAverage, getFeederLabel, getSchoolSet } from './../utils';
import useStore from './../../store';
import PopupContent from './PopupContent';
/**
 * Layout sets up the basic layout for the explorer.
 * @param Object children Child elements
 * @param Object props    Props passed from parent
 */

var MapMobileModal = function MapMobileModal(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]); // Generic state updates for store.
  // Accepts an object of values to update.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Tracks whether or not to display map mobile modal

  var showMapModal = useStore(function (state) {
    return state.showMapModal;
  }); // Closes modal.

  var toggleMapModal = function toggleMapModal() {
    setStoreValues({
      showMapModal: !showMapModal
    });
  };

  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: props.hoveredFeature && showMapModal,
    toggle: toggleMapModal,
    className: 'map-modal',
    backdrop: true,
    keyboard: true,
    autoFocus: true,
    centered: true
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: toggleMapModal
  }), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(PopupContent, {
    feature: props.hoveredFeature
  })));
};

export default MapMobileModal;